import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { alpha, useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { BADGE, INK_BLACK, STATUS, SURFACE } from "@/theme/tokens";
import Style from "./HeaderButton.module.scss";

type Props = {
	onPress: any;
	state: "off" | "on";
	text: string;
	dropdown?: boolean;
	width?: string;
	height?: string;
	icon?: any;
	disabled: boolean;
	secondary?: boolean;
	showNewBadge?: boolean;
	maxWidth?: string;
	dataTestId?: string;
};

export const HeaderButton = ({ onPress, state, text, dropdown, width, height, icon, disabled, secondary, showNewBadge, maxWidth, dataTestId }: Props) => {
	const theme = useTheme();
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const containerClassName = `${Style.buttonContainer} ${Style[state]} ${disabled ? Style.disabled : ""} ${secondary ? Style.secondary : ""}`;

	return (
		<div style={{ position: "relative", display: "inline-block" }}>
			<div
				data-testid={dataTestId}
				className={containerClassName}
				onClick={disabled ? null : onPress}
				style={{
					maxWidth: maxWidth,
					width: width,
					height: height,
					padding: width ? "0px 10px" : "0px",
					opacity: disabled ? 0.5 : 1,
					cursor: disabled ? "not-allowed" : "pointer",
				}}
			>
				<div
					className={Style.button}
					style={{
						marginLeft: dropdown ? "7px" : "0px",
						color: secondary ? theme.palette.primary.main : SURFACE,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: "8px",
						width: "100%",
						height: "100%",
					}}
				>
					{text && (
						<span
							style={{
								fontWeight: "500",
								fontSize: "14px",
								display: "block",
							}}
						>
							{text}
						</span>
					)}
					{dropdown && <ArrowDropDown />}
					{icon}
				</div>
			</div>
			{showNewBadge && (
				<div
					style={{
						position: "absolute",
						top: "-8px",
						right: "-8px",
						backgroundColor: STATUS.ERROR.main,
						color: "white",
						fontSize: "10px",
						fontWeight: "bold",
						padding: "2px 6px",
						borderRadius: `${BADGE.PILL_RADIUS_FULL}px`,
						textTransform: "uppercase",
						lineHeight: "1",
						zIndex: 1000,
						minWidth: "20px",
						textAlign: "center",
						boxShadow: `0 2px 4px ${alpha(INK_BLACK, 0.2)}`,
					}}
				>
					NEW
				</div>
			)}
		</div>
	);
};
